import React, { useRef, useEffect, useState } from 'react';

const TICKER_TEXT = 'Technical Artist\u00A0\u00A0\u00A0\u00A0✦\u00A0\u00A0\u00A0\u00A0Creative Technologist\u00A0\u00A0\u00A0\u00A0✦\u00A0\u00A0\u00A0\u00A0XR Developer\u00A0\u00A0\u00A0\u00A0✦\u00A0\u00A0\u00A0\u00A0';
const SPEED = 40; // pixels per second

const TickerTrack = ({ vertical = false, reverse = false }) => {
  const trackRef = useRef(null);
  const measureRef = useRef(null);
  const offsetRef = useRef(null);
  const [contentSize, setContentSize] = useState(0);

  // Measure the size of one text block
  useEffect(() => {
    const measure = () => {
      if (measureRef.current) {
        const size = vertical ? measureRef.current.offsetHeight : measureRef.current.offsetWidth;
        if (size > 0) {
          setContentSize(size);
        }
      }
    };
    
    // Measure after fonts load
    measure();
    document.fonts?.ready?.then(measure);
  }, [vertical]);

  useEffect(() => {
    if (!contentSize) return;
    
    const track = trackRef.current;
    if (!track) return;

    // Initialize offset only once
    if (offsetRef.current === null) {
      offsetRef.current = 0;
    }

    let lastTime = performance.now();
    let rafId;

    const animate = (currentTime) => {
      const delta = (currentTime - lastTime) / 1000;
      lastTime = currentTime;

      // Update offset based on direction
      const movement = SPEED * delta;
      if (reverse) {
        offsetRef.current += movement;
      } else {
        offsetRef.current -= movement;
      }

      // Use modulo for seamless wrapping (keeps offset in range -contentSize to 0)
      // This avoids any hard reset - it's mathematically continuous
      offsetRef.current = ((offsetRef.current % contentSize) + contentSize) % contentSize;
      const displayOffset = offsetRef.current - contentSize;

      if (vertical) {
        track.style.transform = `translateY(${displayOffset}px) translateZ(0)`;
      } else {
        track.style.transform = `translateX(${displayOffset}px) translateZ(0)`;
      }

      rafId = requestAnimationFrame(animate);
    };

    rafId = requestAnimationFrame(animate);

    return () => {
      if (rafId) cancelAnimationFrame(rafId);
    };
  }, [vertical, reverse, contentSize]);

  const textContent = TICKER_TEXT + TICKER_TEXT;

  return (
    <div 
      ref={trackRef} 
      className={`hero-ticker-track ${vertical ? 'vertical' : ''}`}
      style={{ willChange: 'transform' }}
    >
      <span ref={measureRef}>{textContent}</span>
      <span aria-hidden="true">{textContent}</span>
    </div>
  );
};

const HeroTicker = () => {
  return (
    <>
      {/* Top - scrolls left */}
      <div className="hero-ticker hero-ticker-top">
        <TickerTrack />
      </div>
      
      {/* Right - scrolls up */}
      <div className="hero-ticker hero-ticker-right">
        <TickerTrack vertical />
      </div>
      
      {/* Bottom - scrolls right */}
      <div className="hero-ticker hero-ticker-bottom">
        <TickerTrack reverse />
      </div>
      
      {/* Left - scrolls down */}
      <div className="hero-ticker hero-ticker-left">
        <TickerTrack vertical reverse />
      </div>
    </>
  );
};

export default HeroTicker;
